import { TAdfoxBannerCompleteSizes, TAdfoxBannerSizeProps } from 'shared/types/adfox';

export function getCompleteSizes({ width, height }: TAdfoxBannerSizeProps): TAdfoxBannerCompleteSizes {
  return {
    height,
    maxHeight: height,
    maxWidth: width,
    minHeight: height,
    minWidth: width,
    width,
  };
}
